module.exports = __webpack_public_path__ + "img/ESG.5fb4e911.png";